/* Button2.js */
/* @author: anghello */

import React from 'react';
import './button2.scss';

export default function Button2({ type, loading = false, children, ...rest }) {
  if (type === 'icon') {
    return (
      <button className='button2-icon' {...rest}>
        {children}
      </button>
    );
  }
  return (
    <button className='button2'>
      {children}
    </button>
  );
}